import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Anzeige } from "../shared/anzeige";
import { Observable, throwError } from "rxjs";
import { retry, catchError } from "rxjs/operators";
import { Config } from "../shared/config";

@Injectable({
    providedIn: "root",
})
export class RestApiService {
    k_id: number;
    apiURL: string;
    postId;

    constructor(private http: HttpClient, public conf: Config) {
        this.k_id = Number(this.conf.kundenId);
        this.apiURL = this.conf.dataBaseUrl;
    }

    // Http Options
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        }),
    };

    
    getAnzeigen(): Observable<Anzeige> {
        return this.http
            .get<Anzeige>(this.apiURL + "/read/" + this.k_id)
            .pipe(retry(1), catchError(this.handleError));
    }

    getDetail(anzeigenId): Observable<Anzeige> {
        // console.log("READ      "+this.apiURL + "/read/" + anzeigenId + "/detail");
        return this.http
            .get<Anzeige>(this.apiURL + "/read/" + anzeigenId + "/detail")
            .pipe(retry(1), catchError(this.handleError));
    }

    getKartenDetail(anzeigenId): Observable<Anzeige> {
        // console.log("READ      "+this.apiURL + "/read/" + anzeigenId + "/detail");
        return this.http
            .get<Anzeige>(this.apiURL + "/read/" + anzeigenId + "/detail")
            .pipe(retry(1), catchError(this.handleError));
    }

    setKerze(jsonData): any {
        this.http
            .post(this.apiURL + "/update", jsonData)
            .subscribe((res) => console.log(res));
    }

    confirmKondolenz(jsonData): Observable<string> {
        return this.http
            .post<string>(this.apiURL + "/confirm" , jsonData)
            // .pipe(retry(1), catchError(this.handleError));
    }

    setKondolenz(jsonData): any {
        this.http
            .post(this.apiURL + "/update", jsonData)
            .subscribe((res) => console.log(res));
    }

    // Error handling
    handleError(error) {
        let errorMessage = "";
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        window.alert(errorMessage);
        return throwError(errorMessage);
    }
}

